<template>
  <div>
    <a-menu
      :defaultSelectedKeys="['3-2']"
      :defaultOpenKeys="['3']"
      mode="inline"
      theme="dark"
      :inlineCollapsed="collapsed"
    >
      <a-menu-item key="1" @click="hrefSrc('1')">
        <a-icon type="home" />
        <span>返回主界面</span>
      </a-menu-item>
      <a-sub-menu key="2">
        <span slot="title">
          <a-icon type="audit" />
          <span>工单管理</span>
        </span>
        <a-menu-item key="2-1" @click="hrefSrc('2-1')">光芽</a-menu-item>
        <a-menu-item key="2-2" @click="hrefSrc('2-2')">常规工单</a-menu-item>
        <a-menu-item key="2-3" @click="hrefSrc('2-3')">盘点工单</a-menu-item>
        <a-menu-item key="2-4" @click="hrefSrc('2-4')">调拨工单</a-menu-item>
        <a-menu-item key="2-9" @click="hrefSrc('2-9')">货品退回</a-menu-item>
        <a-menu-item key="2-5" @click="hrefSrc('2-5')">总部发货单</a-menu-item>
        <a-menu-item key="2-8" @click="hrefSrc('2-8')">缺货补货表</a-menu-item>
        <a-menu-item key="2-6" @click="hrefSrc('2-6')"
          >华屹库存变化记录</a-menu-item
        >
        <a-menu-item key="2-7" @click="hrefSrc('2-7')"
          >华屹交易记录</a-menu-item
        >
      </a-sub-menu>
      <a-sub-menu key="4">
        <span slot="title">
          <a-icon type="line-chart" />
          <span>设备管理</span>
        </span>
        <a-menu-item key="4-1" @click="hrefSrc('4-1')">网点设备</a-menu-item>
        <a-menu-item key="4-2" @click="hrefSrc('4-2')">网点员工</a-menu-item>
        <a-menu-item key="4-3" @click="hrefSrc('4-3')">美陈示例</a-menu-item>
      </a-sub-menu>
      <a-sub-menu key="6">
        <span slot="title">
          <a-icon type="line-chart" />
          <span>运营数据</span>
        </span>
        <a-menu-item key="6-1" @click="hrefSrc('6-1')">员工数据</a-menu-item>
        <a-menu-item key="6-2" @click="hrefSrc('6-2')">项目数据</a-menu-item>
      </a-sub-menu>
      <a-sub-menu key="5">
        <span slot="title">
          <a-icon type="audit" />
          <span>物料管理</span>
        </span>
        <a-menu-item key="5-1" @click="hrefSrc('5-1')">商品</a-menu-item>
        <a-menu-item key="5-2" @click="hrefSrc('5-2')">总仓物料</a-menu-item>
        <a-menu-item key="5-3" @click="hrefSrc('5-3')">总仓入库单</a-menu-item>
        <a-menu-item key="5-6" @click="hrefSrc('5-6')">总仓出库单</a-menu-item>
        <a-menu-item key="5-4" @click="hrefSrc('5-4')">总仓盘点单</a-menu-item>
        <a-menu-item key="5-5" @click="hrefSrc('5-5')">网点仓物料</a-menu-item>
      </a-sub-menu>
      <a-sub-menu key="3">
        <span slot="title">
          <a-icon type="smile" />
          <span>用户权限</span>
        </span>
        <a-menu-item key="3-2" @click="hrefSrc('3-2')">管理员</a-menu-item>
        <a-menu-item key="3-1" @click="hrefSrc('3-1')">员工</a-menu-item>
      </a-sub-menu>
    </a-menu>
  </div>
</template>
<script>
export default {
  data() {
    return {
      collapsed: false
    };
  },
  methods: {
    hrefSrc(key) {
      switch (key) {
        case "1":
          this.$router.push({ name: "home" });
          break;
        case "2-1":
          this.$router.push({ name: "equipmentGYOrder" });
          break;
        case "2-2":
          this.$router.push({ name: "equipmentMachineOrder" });
          break;
        case "2-3":
          this.$router.push({ name: "equipmentMachineCheck" });
          break;
        case "2-4":
          this.$router.push({ name: "equipmentGoodsAllocation" });
          break;
        case "2-5":
          this.$router.push({ name: "equipmentMachineIn" });
          break;
        case "2-6":
          this.$router.push({ name: "equipmentHySlotLog" });
          break;
        case "2-7":
          this.$router.push({ name: "equipmentHySalesLog" });
          break;
        case "2-8":
          this.$router.push({ name: "equipmentMistiming" });
          break;
        case "2-9":
          this.$router.push({ name: "equipmentGoodsSendBack" });
          break;
        case "3-1":
          this.$router.push({ name: "equipmentWorker" });
          break;
        case "3-2":
          this.$router.push({ name: "equipmentAdministrator" });
          break;
        case "4-1":
          this.$router.push({ name: "equipmentMachine" });
          break;
        case "4-2":
          this.$router.push({ name: "equipmentDeviceGuard" });
          break;
        case "4-3":
          this.$router.push({ name: "equipmentDisplayExample" });
          break;
        case "5-1":
          this.$router.push({ name: "equipmentGoods" });
          break;
        case "5-2":
          this.$router.push({ name: "equipmentWarehouseMaterial" });
          break;
        case "5-3":
          this.$router.push({ name: "equipmentWarehouseStorageOrder" });
          break;
        case "5-4":
          this.$router.push({ name: "equipmentWarehouseCheckOrder" });
          break;
        case "5-5":
          this.$router.push({ name: "equipmentDeviceMaterial" });
          break;
        case "5-6":
          this.$router.push({ name: "equipmentWarehouseOutOrder" });
          break;
        case "6-1":
          this.$router.push({ name: "equipmentMonthSettlement" });
          break;
        case "6-2":
          this.$router.push({ name: "equipmentProSettlement" });
          break;
      }
    }
  }
};
</script>
